import { render, staticRenderFns } from "./PartnershipForm.vue?vue&type=template&id=2f4ceda1&"
import script from "./PartnershipForm.vue?vue&type=script&lang=js&"
export * from "./PartnershipForm.vue?vue&type=script&lang=js&"
import style0 from "./PartnershipForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports